import React, { Component, PropTypes } from 'react';

import Modal from 'components/Modal';
import { Button } from 'muicss/react';

import { ENTER } from 'constants/ascii';
import GbpSearch from 'components/Gbp/GbpSearch';
import GbpVerificationOptions from 'components/Gbp/GbpVerificationOptions';
import GbpVerificationSubmission from 'components/Gbp/GbpVerificationSubmission';
import {
  GBP_STEPS,
  CREATE_LOCATION,
  LOCATION_DATA_SOURCES,
  GBP_USER_LOCATION_VERIFICATION_STATUS,
  GBP_PROPERTIES,
  PIN_GENERATION_FAILURE,
} from 'constants/gbp';
import AlertModal from 'components/AlertModal/AlertModal';
import GbpCreate from 'components/Gbp/GbpCreate';
import GbpLocation from 'records/GbpLocation';
import { createEvent } from 'googleanalytics';
import { CATEGORIES, ACTIONS } from 'constants/googleAnalytics';
import { validateProperty } from 'components/Gbp/gbpHelper';
import { Set } from 'immutable';
import { getLocationId } from 'components/Gbp/gbpHelper';
import { GBP_VERIFICATION_OPTIONS } from 'constants/gbp';

class GbpClaimModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    brand: PropTypes.object,
    searchLocations: PropTypes.object,
    userLocations: PropTypes.object,
    step: PropTypes.number,
    closeModal: PropTypes.func,
    changeStep: PropTypes.func,
    onSearch: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    isGbpAlertModalOpen: PropTypes.bool,
    locations: PropTypes.object,
    categories: PropTypes.object,
    user: PropTypes.object,
    account: PropTypes.object,
    setAlertVisibility: PropTypes.func,
    fetchCategories: PropTypes.func,
    fetchAccountInfo: PropTypes.func,
    onChangeLocationData: PropTypes.func,
    location: PropTypes.object,
    getGbpLocationVerificationStatus: PropTypes.func,
    getGbpLocationVerificationOptions: PropTypes.func,
    resetLocation: PropTypes.func,
    onCreateAndVerifyLocation: PropTypes.func,
    setGoogleLocationInfo: PropTypes.func,
    fetchUserLocations: PropTypes.func,
    onLinkLocation: PropTypes.func,
    isLoading: PropTypes.bool,
    isSearchLoading: PropTypes.bool,
    locationVerificationMethods: PropTypes.object,
    onGbpUpdateLocation: PropTypes.func,
    startGbpVerificationProcess: PropTypes.func,
    submitGbpVerificationPin: PropTypes.func,
    errorMessage: PropTypes.string,
    categories: PropTypes.array,
    setCategories: PropTypes.func
  };

  constructor() {
    super();
    this.state = {
      searchText: '',
      selected: null,
      isUserLocations: false,
      locationVerificationState: '',
      invalidProps: new Set(),
      isConsentAccepted: false,
      selectedVerificationOption: null,
      locationId: '',
      verificationCode: null,
      previousStep: null,
      isCodeSent: true,
      timer: 60,
    };
  }

  componentDidUpdate({ userLocations: prevUserLocations }) {
    // If user has locations, default to my locations
    if (prevUserLocations.size === 0 && this.props.userLocations.size > 0) {
      this.setState({ isUserLocations: true });
    }
  }

  handleOnSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleAdminRightsUriClick = (adminRightsUri) => {
    const { user } = this.props;
    createEvent(CATEGORIES.GBP, ACTIONS.REQUEST_ADMIN_RIGHTS, `${user.opcoId}-${user.syscoCustomerId}, ${user.id}`, user);
    window.open(adminRightsUri, '_blank');
  }

  handleOnSearchLocation = () => {
    const { user } = this.props;
    createEvent(CATEGORIES.GBP, ACTIONS.SEARCH_LOCATION, `${ user.opcoId }-${ user.syscoCustomerId }, ${ user.id }`, user);
    this.props.onSearch(this.state.searchText);
    this.setState({ selected: null });
  }

  handleLinkLocation = () => {
    const { selected } = this.state;
    const gbpLocationData = {
      title: selected.get('location').get('title'),
      storefrontAddress: {
        addressLines: selected.get('location').get('storefrontAddress').get('addressLines'),
        locality: selected.get('location').get('storefrontAddress').get('locality'),
        regionCode: selected.get('location').get('storefrontAddress').get('regionCode'),
      },
      phoneNumbers: {
        primaryPhone: selected.get('location').get('phoneNumbers').get('primaryPhone'),
      },
    };
    this.props.onLinkLocation(getLocationId(selected), gbpLocationData);
  }

  handleSearchEnter = (e) => {
    if (e.keyCode === ENTER) {
      this.handleOnSearchLocation();
    }
  };

  /**
   * handle next button click - supports multiple pages
   * @param {Object} user user object
   * @param {Integer} currentStep current page step
   */
  handleNext = async (user, currentStep) => {
    const { changeStep, onGbpUpdateLocation, location, startGbpVerificationProcess, submitGbpVerificationPin } = this.props;
    const { locationVerificationState, selected, selectedVerificationOption, verificationCode, locationId } = this.state;
    const source = this.getSource();

    switch (currentStep) {

      // search page
      case GBP_STEPS.SEARCH:
        if (locationVerificationState === GBP_USER_LOCATION_VERIFICATION_STATUS.COMPLETED && source === LOCATION_DATA_SOURCES.MY_LOCATION) {
          createEvent(CATEGORIES.GBP, ACTIONS.LINK_TO_SYSCOSTUDIO, `${user.opcoId}-${user.syscoCustomerId}, ${user.id}`, user);
          this.handleLinkLocation();
          return;
        }
        
        break;

      // location view page
      case GBP_STEPS.CLAIM:
        const invalidProps = this.validateAll();
        if (invalidProps && invalidProps.size) {
          this.setState({ invalidProps });
          return;
        }

        if (source === LOCATION_DATA_SOURCES.MY_LOCATION) {
          await onGbpUpdateLocation();
          this.setState(({ selected: prevSelected }) => ({
            locationId: getLocationId(selected),
            selected: prevSelected.setIn(['location', 'phoneNumbers', 'primaryPhone'], location.get('primaryPhone')),
          }));
        } else {
          const googleLocId = await this.onClaim(user);
          this.setState({ locationId: googleLocId });
        }
        break;
      
      // verification options page
      case GBP_STEPS.VERIFICATION_OPTIONS:
        await startGbpVerificationProcess(locationId, selectedVerificationOption.get(0));
        break;

      // verification code submission
      case GBP_STEPS.ENTER_PIN:
        await submitGbpVerificationPin(verificationCode, false);
    }
    changeStep(currentStep + 1);
  }


  onBack = currentStep => {
    const { changeStep, resetLocation } = this.props;

    this.setState({
      previousStep: currentStep
    });

    changeStep(currentStep - 1, true);

    if (currentStep == GBP_STEPS.SEARCH) {
      resetLocation();
      this.setState({
        selected: null, //reset selected location
        invalidProps: new Set() //reset invalidProps
      });
    }

    if (currentStep == GBP_STEPS.CLAIM) {
      this.setState({
        selectedVerificationOption: null,
        invalidProps: new Set(),
      });
    }

    if (currentStep == GBP_STEPS.ENTER_PIN) {
      this.setTimerValue(60);
    }
  }

  setSelectedSearchItem = (selected) => {
    this.setState({ selected });
    this.setUserLocationVerificationStatus(selected);
    this.setState({ isConsentAccepted: false });
  }

  setUserLocationVerificationStatus = (selected) => {
    const { getGbpLocationVerificationStatus } = this.props;
    const verificationStatus = '';
    if (this.state.isUserLocations && selected !== null && selected.get('name')) {
      if (this.state.isUserLocations) {
        getGbpLocationVerificationStatus(getLocationId(selected)).then((data) => {
          this.setState({ locationVerificationState: data.state });
        })
      }
      else {
        this.setState({ locationVerificationState: verificationStatus });
      }
    }
  }

  handleOnSearchInitialLocation = (searchText) => {
    this.setState({ searchText });
    this.props.onSearch(searchText);
  }

  onToggleAlert = () => {
    const { changeStep, setAlertVisibility } = this.props;

    changeStep(GBP_STEPS.SEARCH);
    setAlertVisibility(false);
  }

  onClaim = (user) => {
    const { location, onCreateAndVerifyLocation } = this.props;
    const { isUserLocations, selected } = this.state;
    const { opcoId, syscoCustomerId } = user;
    const isCreateNewLocation = (selected === CREATE_LOCATION);
    const gbpCreateEntity = GbpLocation.generateGbpCreateEntity(location);

    if (isCreateNewLocation) {
      createEvent(CATEGORIES.GBP, ACTIONS.CREATE_AND_CLAIM, `${opcoId}-${syscoCustomerId}, ${user.id}`, user);
    } else {
      createEvent(CATEGORIES.GBP, ACTIONS.CLAIM_LOCATION, `${opcoId}-${syscoCustomerId}, ${user.id}`, user);
    }

    return onCreateAndVerifyLocation(gbpCreateEntity, isUserLocations, isCreateNewLocation);
  }

  /**
   * Change location data while validating
   * @param {String} key key
   * @param {String} value value
   */
  onChangeLocationData = (value, key) => {
    this.props.onChangeLocationData(value, key);
    this.updatePropertyValidation(key, value);
  }

  /**
   * update state if prop validation is changed
   * @param {String} property property
   * @param {String} value value
   * @param {Boolean} shouldStore should store in state
   * @returns {Set} updated invalid props set
   */
  updatePropertyValidation = (property, value, invalidPropSet = null) => {
    const invalidProps = invalidPropSet || this.state.invalidProps;

    const isValid = validateProperty(property, value, this.getSource());
    const hasProp = invalidProps.has(property);
    let updatedSet;

    if (hasProp && isValid) {
      updatedSet = invalidProps.delete(property);
    } else if (!hasProp && !isValid) {
      updatedSet = invalidProps.add(property);
    }

    if (updatedSet && !invalidPropSet) {
      this.setState({
        invalidProps: updatedSet,
      })
    }

    return updatedSet || new Set(invalidProps);
  }

  /**
   * Validate all the properties
   * @returns {Set} all the invalid props set
   */
  validateAll = () => {
    const { location } = this.props;
    let invalidPropSet = new Set();

    for (const property of Object.values(GBP_PROPERTIES)) {
      invalidPropSet = this.updatePropertyValidation(property, location.get(property), invalidPropSet);
    }
    return invalidPropSet;
  }

  /**
   * derive flow source
   * @returns {String} source
   */
  getSource = () => {
    const { selected, isUserLocations } = this.state;
    let source;
    if (isUserLocations) {
      source = LOCATION_DATA_SOURCES.MY_LOCATION;
    } else if (selected === CREATE_LOCATION) {
      source = LOCATION_DATA_SOURCES.NEW_LOCATION;
    } else {
      source = LOCATION_DATA_SOURCES.GBP_EXISTING_LOCATION;
    }
    return source;
  }

  onToggleRadioButton = (isUserLocations) => {
    this.setState({
      isUserLocations: isUserLocations,
      selected: null,
      locationVerificationState: '',
      isConsentAccepted: false
    });
  }

  onToggleCheckBox = () => {
    this.setState((prevState) => ({ isConsentAccepted: !prevState.isConsentAccepted }));
  }

  renderFooterText = () => {
    const { searchText, selected, locationVerificationState, isConsentAccepted } = this.state;
    let footertext = '';
    let footertext2 = '';
    let requestAdminRights = null;

    if (typeof selected === 'object' && selected !== null) {
      const locationName = selected.get('location') && selected.get('location').get('title') ? selected.get('location').get('title') : 'Location';
      if (selected.get('requestAdminRightsUri')) {
        requestAdminRights = <a href="#" target='_blank' onClick={() => this.handleAdminRightsUriClick(selected.get('requestAdminRightsUri'))}>request for admin rights?</a>;
        footertext = `${locationName} is already claimed with Google. Would you like to `;
      }
      else if (locationVerificationState === GBP_USER_LOCATION_VERIFICATION_STATUS.COMPLETED) {
        footertext = `${locationName} is already claimed with Google. Would you like to link the business with Sysco Studio?`;
      }
      else {
        footertext = 'This process will claim your business in Google and will provide access to Sysco Restaurant Solutions team to help manage your business on Google on behalf of you.'
        footertext2 = 'I hereby confirm that this location is under my ownership and I have the authority to claim and verify this location';
      }
    } else if (selected === CREATE_LOCATION) {
      footertext = `Would you like to create a new location, ${searchText}?`;
    }

    return (
      <div className={'modal-text-description mt-20'}>
        {footertext}
        {requestAdminRights || ''}
        <div className='modal-text-description mt-15'>
          {footertext2 ?
            <div className={'custom-toggle checkbox'}>
              <input
                type={'checkbox'}
                id={`checkbox-gbp-consent`}
                key={`checkbox-gbp-consent`}
                name={'confirm-option'}
                value={'confirmed'}
                onChange={this.onToggleCheckBox}
                checked={isConsentAccepted}
              />
              <label htmlFor={'checkbox-gbp-consent'}>{footertext2}</label>
            </div>
            : null
          }
        </div>
      </div>
    );
  };

  renderSearchStep() {
    const {
      searchLocations,
      userLocations,
      brand,
      fetchUserLocations,
      isSearchLoading,
      isLoading,
    } = this.props;
    const { searchText, selected, isUserLocations } = this.state;

    return (
      <div>
        {
          userLocations.size > 0 ? (
            <div className={'flex mt-15'}>
              <div className={'custom-toggle radio mr-20'}>
                <input
                  type={'radio'}
                  name={'location'}
                  id={'my_locations'}
                  value={'my_locations'}
                  checked={isUserLocations}
                  onChange={() => this.onToggleRadioButton(true)}
                />
                <label htmlFor={`my_locations`}>My Locations</label>
              </div>
              <div className={'custom-toggle radio'}>
                <input
                  type={'radio'}
                  name={'location'}
                  id={'all_locations'}
                  value={'all_locations'}
                  checked={!isUserLocations}
                  onChange={() => this.onToggleRadioButton(false)}
                />
                <label htmlFor={`all_locations`}>All Locations</label>
              </div>
            </div>) : null
        }
        {isUserLocations && userLocations.size > 0 && <div className='modal-text-description mb-11'>Note: ‘My Locations’ will show accounts tied to the email address used to login to Sysco Studio, use that area to link your existing location to your Sysco Studio Account for easy access.</div>}
        {isUserLocations ?
          null :
          <p className={'modal-text-description'}>
            Refine the search accordingly to locate your business
          </p>
        }
        <GbpSearch
          brand={brand}
          handleOnSearchInitialLocation={this.handleOnSearchInitialLocation}
          handleSearchEnter={this.handleSearchEnter}
          handleOnSearchTextChange={this.handleOnSearchTextChange}
          searchText={searchText}
          handleOnSearchLocation={this.handleOnSearchLocation}
          locations={isUserLocations ? userLocations : searchLocations}
          selected={selected}
          setSelectedSearchItem={this.setSelectedSearchItem}
          isUserLocations={isUserLocations}
          fetchUserLocations={fetchUserLocations}
          isSearchLoading={isSearchLoading}
          isLoading={isLoading}
        />
      </div>
    );
  }

  renderLocationViewStep() {
    const {
      fetchCategories,
      fetchAccountInfo,
      location: {
        title,
        profile,
        regionCode,
        postalCode,
        administrativeArea,
        locality,
        streetAddress,
        primaryCategoryId,
        primaryPhone,
      },
      location,
      setGoogleLocationInfo,
      isLoading,
      setCategories,
      categories
    } = this.props;
    const { selected, invalidProps, previousStep } = this.state;

    return <GbpCreate
      onChange={this.onChangeLocationData}
      fetchCategories={fetchCategories}
      fetchAccountInfo={fetchAccountInfo}
      title={title}
      description={profile}
      country={regionCode}
      postalCode={postalCode}
      state={administrativeArea}
      city={locality}
      streetAddress={streetAddress}
      category={primaryCategoryId}
      phone={primaryPhone}
      source={this.getSource()}
      selected={selected}
      setGoogleLocationInfo={setGoogleLocationInfo}
      isLoading={isLoading}
      invalidProps={invalidProps}
      previousStep={previousStep}
      location={location}
      categories={categories}
      setCategories={setCategories}
    />;
  }

  renderVerificationOptions() {
    const {
      getGbpLocationVerificationOptions,
      isLoading,
      locationVerificationMethods
    } = this.props;
    const { locationId } = this.state;

    return (
      <div>
        <GbpVerificationOptions
          getGbpLocationVerificationOptions={getGbpLocationVerificationOptions}
          locationVerificationMethods={locationVerificationMethods}
          isLoading={isLoading}
          locationId={locationId}
          setSelectedVerficationOption={this.setSelectedVerficationOption}
        />
      </div>
    );

  }

  buildVerificatioCodeSubmissionMessage = () => {
    const { selectedVerificationOption } = this.state;
    const method = selectedVerificationOption.get(0).get("verificationMethod")

    switch (method) {
      case GBP_VERIFICATION_OPTIONS.EMAIL:
        return "The verification code was sent to " +  selectedVerificationOption.get(0).get("emailData");
      case GBP_VERIFICATION_OPTIONS.PHONE_CALL:
        return "A voice call was made to " +  selectedVerificationOption.get(0).get("phoneNumber");
      case GBP_VERIFICATION_OPTIONS.SMS:
        return "A text was sent to " +  selectedVerificationOption.get(0).get("phoneNumber");
      default:
        return "The verification code was sent."
    }
  }

  setSelectedVerficationOption = (verificationOption) => {
    this.setState({ selectedVerificationOption: verificationOption })
  };

  resendVerificationCode = async () => {
    const { selectedVerificationOption, locationId } = this.state;
    const { startGbpVerificationProcess } = this.props;

    await startGbpVerificationProcess(
      locationId,
      selectedVerificationOption.get(0)
    );
  };

  setVerificationCode = (pin) => {
    this.setState({ verificationCode: pin })
  }

  countDown = () => {
    this.setState((prevState) => ({
      timer: prevState.timer - 1,
    }));
  }

  setVerificationCodeStatus = (isSent) => {
    this.setState({
      isCodeSent: isSent,
    });
  }

  setTimerValue = (value) => {
    this.setState({ timer: value });
  }

  renderEnterPin() {
    const { isCodeSent, timer } = this.state;
    const message = this.buildVerificatioCodeSubmissionMessage();

    return (
      <GbpVerificationSubmission
        setVerificationCode={this.setVerificationCode}
        resendVerificationCode={this.resendVerificationCode}
        messageText={message}
        isCodeSent={isCodeSent}
        timer={timer}
        countDown={this.countDown}
        setVerificationCodeStatus={this.setVerificationCodeStatus}
        setTimerValue={this.setTimerValue}
      />
    );
  }

  deriveNextButtonText = (step, selected, locationVerificationState) => {
    const isCreateLocationPath = selected === CREATE_LOCATION;
    const isLocationVerified = locationVerificationState === GBP_USER_LOCATION_VERIFICATION_STATUS.COMPLETED;
    switch (step) {
      case GBP_STEPS.SEARCH:
        return isCreateLocationPath ? 'Create Location' : isLocationVerified ? 'Link to Sysco Studio' : 'Verify';
      case GBP_STEPS.CLAIM:
        return 'Claim';
      case GBP_STEPS.ENTER_PIN:
        return 'Submit Code'
      default:
        return "Next";
    }
  }

  /**
   * Derive Error message
   * @param {Number} step gbp page
   * @param {Boolean} hasError has error
   * @returns {String} error message to be shown
   */
  deriveErrorMessage = (step, hasError) => {
    if (!hasError) {
      return null;
    }

    switch (step) {
      case GBP_STEPS.VERIFICATION_OPTIONS:
        return 'An error occured';
      case GBP_STEPS.ENTER_PIN:
        return 'An error occurred. Please enter a valid pin code';
      case 'GENERATE_PIN':
        return 'An error occurred. Please try again';
      default:
        return 'An error occurred. Please review the details and try again';
    }
  }

  /**
   * check whether button should be 
   * disabled based on conditions
   * @returns {boolean} true if conditions satisfy, else false
   */
  disableButton = () => {
    const {
      step,
      isLoading,
      isSearchLoading,
    } = this.props;
    const {
      selected,
      locationVerificationState,
      isConsentAccepted,
      selectedVerificationOption,
      invalidProps,
    } = this.state;

    const isCreateLocationPath = selected === CREATE_LOCATION;
    const isLocationVerified = locationVerificationState === GBP_USER_LOCATION_VERIFICATION_STATUS.COMPLETED;
    const allowCreate = isLocationVerified || isCreateLocationPath ? !!selected : isConsentAccepted;

    if (step === GBP_STEPS.VERIFICATION_OPTIONS) {
      return (isLoading || !selectedVerificationOption);
    }
    else {
      return (isSearchLoading || isLoading || !allowCreate || invalidProps.size);
    }
  }

  renderNextButton() {
    const {
      step,
      user,
    } = this.props;
    const {
      selected,
      locationVerificationState,
    } = this.state;

    const isCreateLocationPath = selected === CREATE_LOCATION;

    return (selected === null || isCreateLocationPath || !selected.get('requestAdminRightsUri')) ?
      <Button
        className='mui-btn--success'
        type='button'
        disabled={this.disableButton()}
        onClick={() => this.handleNext(user, step)}
      >{this.deriveNextButtonText(step, selected, locationVerificationState)}</Button> :
      null;
  }

  /**
   * Render header
   * @param {String} subTitle 
   * @param {String} error error mesage
   */
  renderHeader = (subTitle, error) => (<div>
    Find and manage your business

    {!!subTitle ? <p className={`modal-text-description mt-10`}>{subTitle}</p> : null}
    {!!error ? <p className={`error-txt font-15 mt-10`}>{error}</p> : null}
  </div>);

  renderBody() {
    switch (this.props.step) {
      case GBP_STEPS.SEARCH:
        return this.renderSearchStep();
      case GBP_STEPS.CLAIM:
        return this.renderLocationViewStep();
      case GBP_STEPS.VERIFICATION_OPTIONS:
        return this.renderVerificationOptions();
      case GBP_STEPS.ENTER_PIN:
        return this.renderEnterPin();
      default:
        return <div></div>;
    }
  }

  renderFooter() {
    const {
      step,
      closeModal,
    } = this.props;
    const { selected, isCodeSent, timer } = this.state;
    const isBackDisabled = (isCodeSent || timer > 0) && step == GBP_STEPS.ENTER_PIN;

    return (
      <div>
        {step === GBP_STEPS.SEARCH && selected ? this.renderFooterText() : null}
        <div className={'mui--pull-right'}>
          <Button className='mui-btn--secondary' type='button' onClick={closeModal}>Close</Button>
          {
            step > GBP_STEPS.SEARCH ?
              <Button className='mui-btn--success'
                type='button'
                disabled={isBackDisabled}
                onClick={() => this.onBack(step)}
              >
                Back
              </Button> : null
          }
          {this.renderNextButton()}
        </div>
      </div>
    );
  }

  render() {
    const { isOpen, closeModal, isAuthenticated, step, isGbpAlertModalOpen, errorMessage: error } = this.props;
    const subTitle = step === GBP_STEPS.CLAIM ? 'Review and edit your business information' : null;
    const stepForError = error === PIN_GENERATION_FAILURE ? 'GENERATE_PIN' : step;
    const errorMessage = this.deriveErrorMessage(stepForError, !!error);

    return (
      <div>
        <Modal
          open={isOpen}
          onCloseModal={closeModal}
          contentComponent={this.renderBody()}
          headerComponent={this.renderHeader(subTitle, errorMessage)}
          width={'common-regular-overlay-body'}
          footerComponent={this.renderFooter()}
          disableScroll
        />

        <AlertModal
          showAlert={!isAuthenticated && step != GBP_STEPS.OVERVIEW && isGbpAlertModalOpen}
          alertMessage={'Your Google Session has expired. Please use SyscoStudio Google Business Profile to login!'}
          onToggleAlertModal={this.onToggleAlert}
        />
      </div>
    );
  }
}
export default GbpClaimModal;
